import { Image, Skeleton, Input, Button } from "antd";
import "../../css/jobs.css";
import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import "../../css/chats.css";
import { useAppDispatch, useAppSelector } from "../../store/store";
import {
  useGetAppliedJobsMutation,
  useGetCandidateSkillsMutation,
  useGetMatchedJobsMutation,
} from "../../store/jobsSlice";
import CompanyAvatar from "../../components/Avatars/CompanyAvatar";
import { useLocation, useNavigate } from "react-router-dom";
import ProgressComponent from "../../components/ProgressComponent";
import {
  useGetInterviewsListingMutation,
  useLazyProfileCompleteCheckQuery,
  useUpdateProfileMutation,
} from "../../store/appSlice";
import { setInterviews, setProfileData } from "../../reducers/userReducer";
import { CandidateSkillType, InterviewType } from "../../interfaces/user";
import { isEmpty, isNil, reduce } from "lodash";
import ChatCard from "../../components/chats/ChatCard";
import "react-loading-skeleton/dist/skeleton.css";
import NoJobOpening from "../../assets/images/job-opening.svg";
import GreenMessage from "../../assets/images/green-int-lines.svg";

import Loader from "../../components/Loader";
import { useGetProfileDataFromDBMutation } from "../../store/profileSlice";
import ButtonToggler from "../../components/ButtonsToggler";
import { SELECTED_NAV_OPTION } from "../../constants/stringConstants";
import { setNavOption } from "../../reducers/commonReducer";
import ModalContainer from "../../components/ModalContainer";
import WelcomeModal from "../../components/WelcomeModal";
import HeaderModalText from "../../components/HeaderModalText";

const { TextArea } = Input;

function Jobs() {
  const { user, profileData } = useAppSelector((state) => state["user"]);
  const [suggestionText, setSuggestionText] = useState("");
  const [matchedJobs, setMatchedJobs] = useState<Array<any>>([]);
  const [appliedJobs, setAppliedJobs] = useState<Array<any>>([]);
  const [interviewsListing, setInterviewsListing] = useState<any>({});
  const [hardSkills, setHardSkills] = useState<Array<CandidateSkillType>>([]);
  const [softSkills, setSoftSkills] = useState<Array<CandidateSkillType>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSuggestionLoading, setSuggestionLoading] = useState<boolean>(false);
  const [mainLoader, setMainLoader] = useState<boolean>(true);
  const [isMatchedJobsSelected, setIsMatchedJobsSelected] =
    useState<boolean>(true);
  const [showSuggestionModal, setShowSuggestionModal] =
    useState<boolean>(false);
  const [trigger, { data: profileStatus }] = useLazyProfileCompleteCheckQuery();
  const { selectedNavbarOption } = useAppSelector((state) => state["common"]);
  const [getMatchedJobs] = useGetMatchedJobsMutation();
  const [getAppliedJobs] = useGetAppliedJobsMutation();
  const [getInterviewsListing] = useGetInterviewsListingMutation();
  const [getCandidateSkills] = useGetCandidateSkillsMutation();
  const [getProfileDataFromDB] = useGetProfileDataFromDBMutation();
  const [updateProfile] = useUpdateProfileMutation();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log({ user });
    if (!isNil(user)) {
      trigger(user?.id, true);
    }
    if (location?.state?.fromSignupCompletion) {
      setShowSuggestionModal(true);
    }
  }, []);

  useEffect(() => {
    if (isNil(user) || !isNil(profileStatus)) {
      if (isNil(user) || !profileStatus?.isSignUpProcessCompleted) {
        navigate("/auth/login", { replace: true });
      } else {
        navigateToPage();
        getProfileDetailsFromDb();
        setMainLoader(false);
        setLoading(true);
        getScheduledInterviews();
        getMatchedJobsFromDB();
        getAppliedJobsFromDB();
        getSkillsOfCandidate();
      }
    }
  }, [profileStatus]);

  const navigateToPage = () => {
    switch (selectedNavbarOption) {
      case SELECTED_NAV_OPTION.JOBS:
        navigate("/");
        break;

      case SELECTED_NAV_OPTION.CHATS:
        navigate("/chats");
        break;

      case SELECTED_NAV_OPTION.INTERVIEWS:
        navigate("/interviews");
        break;

      case SELECTED_NAV_OPTION.TEST_CENTER:
        navigate("/testCenter");
        break;

      case SELECTED_NAV_OPTION.PROFILE:
        navigate("/auth/profile");
        break;
    }
  };

  const getProfileDetailsFromDb = async () => {
    const filterDetails = encodeURIComponent(`
    
{
    "fields": {
        "id": true,
        "title": true,
        "profilePicture": true,
        "town": true,
        "aboutYou": true,
        "video": true,
        "yearsOfExperience": true,
        "industryIds": true,
        "professionIds": true,
        "skillIds": true,
        "userId": true,
        "country": true,
        "city": true,
        "location":true
    },
    
    "include": [{
            "relation": "candidateWorkExperiences"
            
        },
        {
            "relation": "candidateEducations"
        },
        {
            "relation": "candidateCertificates"
        },
        {
            "relation": "candidatePortfolios"
              
        },
        {
            "relation": "candidateJobCriteria"
              
        },
        {
            "relation": "user"
        }
    ]
}
`);

    let payload = {
      filterDetails,
      param: user?.id ?? "",
    };
    console.log({ payload });
    getProfileDataFromDB(payload)
      .unwrap()
      .then((incomingData) => {
        console.log({ incomingDataProfilei: incomingData });
        dispatch(setProfileData(incomingData));
      })
      .catch((err) => {
        console.log("error");

        console.log(err);
      });
  };

  const getSkillsOfCandidate = () => {
    const filterObj = encodeURIComponent(` 
  {

      "where":{
      "candidateId":"${user?.id}"
  
      },
      "include":[
      {

        "relation":"candidateTests","scope":{"order": "createdAt DESC","where":{"isAttempted":true}}
      },
      {
        "relation":"test", "scope":{"include":[{"relation":"testQuestions"}]}
      }
      ]
  }
  `);
    const payload = {
      filterObj,
    };

    getCandidateSkills(payload)
      .unwrap()
      .then((incomingData: Array<CandidateSkillType>) => {
        const filteredDataIfNotNull = reduce(
          incomingData,
          function (arr: Array<CandidateSkillType>, el) {
            // Only add to the array if the test function is true
            if (el.candidateTests) {
              arr.push(el);
            }

            // Always return the same array so you can keep filling it
            return arr;
          },
          []
        ); // Give it an empty

        let hardSkills: Array<CandidateSkillType> = [];
        let softSkills: Array<CandidateSkillType> = [];
        filteredDataIfNotNull.map((item: CandidateSkillType) => {
          if (item?.test?.testCategory === "Softskill") {
            softSkills.push(item);
          } else {
            hardSkills.push(item);
          }
        });

        setHardSkills(hardSkills);
        setSoftSkills(softSkills);
        setLoading(false);

        console.log({ skillsFilter: filteredDataIfNotNull });

        console.log({ incomingSKillsDetails: incomingData });
      })
      .catch((err) => {
        console.log("error");

        console.log(err);
      });
  };

  const getAppliedJobsFromDB = async () => {
    const filterObj = encodeURIComponent(`{
      "limit" : 100,
      "offset" : 0,
      "where": {
          "or":[{"applicationStatus" : "Awaiting"},{"applicationStatus" : "Not a Good Fit"}, {"applicationStatus" : "On Hold"}, {"applicationStatus" : "Hired"}, {"applicationStatus" : "Shortlist Candidate"}, {"applicationStatus" : "Reviewed"}]
      },
      "order": "createdAt DESC",
      "include": [
        {
          "relation": "companyJob",
          "scope": {
          "where": {
            "isJobDeleted": false

          },
            "include": [
              {
                "relation": "company"
              }
            ]
          }
        }
      ]
  }`);

    const payload = {
      filterObj,
      param: user?.id,
    };

    getAppliedJobs(payload)
      .unwrap()
      .then((incomingData: any) => {
        console.log({ incomingChatsDetailsApplied: incomingData });
        const filteredDataIfNotNull = Object.values(
          incomingData?.reduce(
            (acc: any, cur: any) =>
              Object.assign(acc, { [cur.companyJobId]: cur }),
            {}
          )
        );

        setAppliedJobs(filteredDataIfNotNull);
        console.log({ filteredDataIfNotNull });
      })
      .catch((err) => {
        console.log("error");

        console.log(err);
      });
  };

  const getMatchedJobsFromDB = async () => {
    const filterObj = encodeURIComponent(`{
          "limit" : 100,
          "offset" : 0,
          "order": "createdAt DESC",
          "include": [
            {
              "relation": "companyJob",
              "scope": {
              "where": {
                "isJobDeleted": false

              },
                "include": [
                  {
                    "relation": "company"
                  }
                ]
              }
            }
          ]
    }`);

    const payload = {
      filterObj,
      param: user?.id,
    };

    getMatchedJobs(payload)
      .unwrap()
      .then((incomingData: any) => {
        console.log({ incomingChatsDetails: incomingData });
        const filteredDataIfNotNull = Object.values(
          incomingData?.reduce(
            (acc: any, cur: any) =>
              Object.assign(acc, { [cur.companyJobId]: cur }),
            {}
          )
        );

        setMatchedJobs(filteredDataIfNotNull);

        console.log({ filteredDataIfNotNull });
      })
      .catch((err) => {
        console.log("error");

        console.log(err);
      });
  };

  const getScheduledInterviews = () => {
    getInterviewsListing(user?.id)
      .unwrap()
      .then((interviews: InterviewType) => {
        console.log({ interviews });
        setInterviewsListing(interviews);
        dispatch(setInterviews(interviews));
      });
  };

  const skillSec = (item: CandidateSkillType) => (
    <div className="jobs_skills_sec_item">
      <text>{item?.test?.content}</text>
      <div>
        <ProgressComponent
          type="circle"
          width={40}
          percentage={item?.candidateTests![0]?.result}
          showInfo={true}
        />
      </div>
    </div>
  );

  const accessBtnSec = (text: string) => (
    <div
      className="skills_access_btn_wrapper"
      onClick={() => {
        dispatch(setNavOption(SELECTED_NAV_OPTION.TEST_CENTER));
        navigate("/testCenter", {
          state: { isHardSkill: text === "View Hard Skills" ? true : false },
        });
      }}
    >
      <div className="skills_access_btn_container">
        <text style={{ color: "white", fontSize: 12 }}>{text}</text>
      </div>
    </div>
  );

  const isJobsDataEmpty = () => {
    if (isMatchedJobsSelected) {
      return !isEmpty(matchedJobs);
    } else {
      return !isEmpty(appliedJobs);
    }
  };








  

  const getJobsDataToRender = () => {
    if (isMatchedJobsSelected) {
      return matchedJobs;
    } else {
      return appliedJobs;
    }
  };
  
  return (
    <div>
      {mainLoader ? (
        <Loader loader={mainLoader} />
      ) : (
        <>
          <Navbar />
          <div style={{ marginTop: 70 }}>
            <div className="header_text_container">
              <text className="header_text">Job Matches</text>
            </div>
  
            <div className="jobs_content_sec">
              {/* skills */}
              <div className="skills_container">
                <div className="jobs_skills_sec">
                  {/* ///hard skills */}
                  <text className="skills_header_text">Hard Skill Ratings</text>
                  {!isEmpty(hardSkills) ? (
                    <div className="skills_listing" style={{ marginTop: "14px" }}>
                      {hardSkills.slice(0, 4).map((item: CandidateSkillType) => {
                        return skillSec(item);
                      })}
                    </div>
                  ) : loading ? (
                    <div className="hardSkill_softSkills_shimmer">
                      <Skeleton paragraph={{ rows: 3, width: "90%" }} />
                    </div>
                  ) : (
                    <div className="skills_sec_empty">
                      <div>
                        <div className="empty_sec">
                          <img src={GreenMessage} alt="" />
                          <text>No hard skill tests taken</text>
                        </div>
                      </div>
                    </div>
                  )}
  
                  {!isEmpty(hardSkills) && accessBtnSec("View Hard Skills")}
  
                  {/* ///soft skills */}
                  <text className="skills_header_text">Soft Skill Ratings</text>
  
                  {!isEmpty(softSkills) ? (
                    <div className="skills_listing" style={{ marginTop: "14px" }}>
                      {softSkills.slice(0, 4).map((item: CandidateSkillType) => {
                        return skillSec(item);
                      })}
                    </div>
                  ) : loading ? (
                    <div className="hardSkill_softSkills_shimmer">
                      <Skeleton paragraph={{ rows: 3, width: "90%" }} />
                    </div>
                  ) : (
                    <div className="skills_sec_empty">
                      <div>
                        <div className="empty_sec">
                          <img src={GreenMessage} alt="" />
                          <text>No soft skill tests taken</text>
                        </div>
                      </div>
                    </div>
                  )}
  
                  {!isEmpty(softSkills) && accessBtnSec("View Soft Skills")}
                </div>
              </div>
  
              {/* //matchedJobs */}
              <div className="matchedAndScheduledContainer">
                <div className="job_listing_wrapper">
                  <div style={{ marginLeft: "5px" }}>
                    <ButtonToggler
                      onFirstBtnTap={() => {
                        setIsMatchedJobsSelected(true);
                      }}
                      onSecondBtnTap={() => {
                        setIsMatchedJobsSelected(false);
                      }}
                      firstBtnText={"Matched Jobs"}
                      secondBtnText={"Applied Jobs"}
                      isFirstBtnSelected={isMatchedJobsSelected}
                    />
                  </div>
                  <div className="job_listing_container">
                    {isJobsDataEmpty() ? (
                      getJobsDataToRender().map((item, index) => {
                        console.log({ index, item });
                        // Add defensive checks before accessing properties
                        const jobTitle = item?.companyJob?.jobTitle ?? "Unknown Job Title";
                        const jobType = item?.companyJob?.jobType ?? "Unknown Job Type";
                        const companyLogo = item?.companyJob?.company?.companyLogo;
                        const workType = item?.companyJob?.workType ?? "Unknown Work Type";
                        const city = item?.companyJob?.city ?? "Unknown City";
                        const country = item?.companyJob?.country ?? "Unknown Country";
                        const percentage = item?.percentage;
  
                        return (
                          <div
                            className="job_listing_item"
                            onClick={() =>
                              navigate("/jobs/job-description", {
                                state: {
                                  companyId: item.companyJob.company.id,
                                  companyJobId: item.companyJobId,
                                  jobMatchPercentage: item?.percentage,
                                },
                              })
                            }
                          >
                            <div className="job_listing_item_img_container">
                              {companyLogo ? (
                                <Image
                                  src={companyLogo}
                                  className="job_listing_item_img_style"
                                  preview={false}
                                />
                              ) : (
                                <CompanyAvatar />
                              )}
                            </div>
                            <div className="job_listing_item_container">
                              <div className="job_listing_item_content">
                                <div>
                                  <div>
                                    <text>{jobTitle}</text>
                                  </div>
                                  <div>
                                    <text>{jobType}</text>
                                  </div>
                                </div>
  
                                <div>
                                  {workType === "Fully Remote" ? (
                                    <text>{workType}</text>
                                  ) : (
                                    <text>{`${city}, ${country}`}</text>
                                  )}
                                </div>
                              </div>
                              <div>
                                {!isNil(percentage) && (
                                  <div className="progress_bar_style">
                                    <ProgressComponent
                                      type="line"
                                      percentage={percentage}
                                    />
                                  </div>
                                )}
                                {!isNil(percentage) && (
                                  <text
                                    style={{
                                      fontSize: 10,
                                      fontWeight: 600,
                                      color: "#454242",
                                    }}
                                  >
                                    Hiring Likelihood
                                  </text>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : loading ? (
                      <>
                        <Skeleton
                          active
                          avatar={{ size: 100, shape: "square" }}
                          paragraph={{ rows: 2, style: { marginBottom: 35 } }}
                        />
                        <Skeleton
                          active
                          avatar={{ size: 100, shape: "square" }}
                          paragraph={{ rows: 2, style: { marginBottom: 35 } }}
                        />
                        <Skeleton
                          active
                          avatar={{ size: 100, shape: "square" }}
                          paragraph={{ rows: 2, style: { marginBottom: 35 } }}
                        />
                        <Skeleton
                          active
                          avatar={{ size: 100, shape: "square" }}
                          paragraph={{ rows: 2, style: { marginBottom: 35 } }}
                        />
                        <Skeleton
                          active
                          avatar={{ size: 100, shape: "square" }}
                          paragraph={{ rows: 2, style: { marginBottom: 35 } }}
                        />
                      </>
                    ) : (
                      <div
                        style={{
                          width: "105%",
                          height: "50vh",
                          marginTop: "20px",
                        }}
                      >
                        <div>
                          <div className="empty_sec">
                            <img src={NoJobOpening} alt="" />
                            <text>
                              {isMatchedJobsSelected
                                ? "Job list loading or it's picky. Your perfect job match is on the way!"
                                : "No Jobs found"}
                            </text>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
  
                {/* //scheduled interviews */}
                <div
                  className={`job_sec_scheduled_interviews_container ${
                    isEmpty(interviewsListing) &&
                    "job_sec_scheduled_interviews_container_loader_width"
                  }`}
                >
                  <div className="job_sec_scheduled_interviews">
                    <div style={{ marginTop: "2px", marginBottom: "10px" }}>
                      <text className="skills_header_text">
                        Scheduled Interviews
                      </text>
                    </div>
                    {!isEmpty(interviewsListing) ? (
                      interviewsListing.map(
                        (chat: InterviewType, index: number) => {
                          //  console.log(chat.fromUser)
                          return (
                            <div style={{ marginBottom: "10px" }}>
                              <ChatCard data={chat} />
                            </div>
                          );
                        }
                      )
                    ) : loading ? (
                      <div className="scheduled_interviews_shimmer">
                        <Skeleton paragraph={{ rows: 6, width: "90%" }} />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "50vh",
                          marginTop: "30%",
                        }}
                      >
                        <div>
                          <div className="empty_sec">
                            <img
                              src={GreenMessage}
                              alt=""
                              style={{ height: "100px", width: "100px" }}
                            />
                            <text>No Scheduled interviews Found</text>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <WelcomeModal
        onClose={() => setShowSuggestionModal(false)}
        isVisible={showSuggestionModal}
        modalHeaderText={"Profile"}
        modalSubHeaderText={"Your preferences"}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <div>
              <h1>Welcome, {profileData?.candidate?.user?.name}!</h1>
              <p>Thanks for joining us. We're delighted to have you here!</p>
              <p>
                Explore and enjoy your journey with us. If you have any
                suggestions or feedback, we'd love to hear from you.
              </p>
              <p>
                Feel free to share your thoughts and make this experience even
                better for everyone!
              </p>
            </div>
          </div>
          <TextArea
            placeholder="Your suggestions..."
            value={suggestionText}
            onChange={(e) => setSuggestionText(e.target.value)}
            style={{ width: "100%", height: 120, resize: "none" }}
            maxLength={400}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-end",
            justifyContent: "flex-end",
            gap: 20,
          }}
        >
          <div
            onClick={() => setShowSuggestionModal(false)}
            style={{
              textDecoration: "underline",
              color: "grey",
              textDecorationColor: "grey",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Skip
          </div>
          <Button
            loading={isSuggestionLoading}
            disabled={isEmpty(suggestionText) || isSuggestionLoading}
            type="primary"
            htmlType="submit"
            style={{
              width: "30%",
              height: "40px",
              marginTop: 15,
              opacity: isEmpty(suggestionText) ? 0.7 : 1,
            }}
            onClick={() => {
              setSuggestionLoading(true);
              const payload = {
                param: user?.id,
                candidateFeedback: suggestionText,
              };

              updateProfile(payload)
                .unwrap()
                .then((incomingData) => {
                  setSuggestionLoading(false);

                  console.log({ insideUpdate: incomingData });

                  setShowSuggestionModal(false);
                });
            }}
          >
            Submit
          </Button>
        </div>
      </WelcomeModal>
    </div>
  );
}

export default Jobs;
